const ckeditorConstants = {
    DEFAULT_INDENTATION_SIZE: 20, // px
};

module.exports = ckeditorConstants;
